<template>
  <div class="helpPayFor">
      <!-- 顶部用户信息 -->
    <div class="top-con">
        <div class="user-img">
            <img :src="userHeadImg" alt="">
        </div>
        <div class="user-message">
            <div class="user-nickName-phone">
                <div class="nickName">{{userNickName}}</div>
                <div class="phone">({{userPhone}})</div>
            </div>
            <!-- 友情提示 -->
            <div class="tips">"我在培考通看中了商品，快帮我付款吧!"</div>
        </div>
    </div>
    <!-- 店铺及商品名称 -->
    <div class="shop-goods-content">
        <div class="shop-nick">{{shopNick}}</div>
        <div class="goods-name">《{{goodsName}}》</div>
    </div>
    <!-- 帮付款 -->
    <div class="pay-for-content">
        <!-- 代付金额 -->
        <div class="need-hlep-pay" v-if="helpPayForFlag==true">
            <div class="pay-for-money-text">代付金额:</div>
            <div class="pay-for-money-price-con">
                <div class="pay-for-money-before">￥</div>
                <div class="pay-for-money-price">{{payForMoney}}</div>
            </div>
            <!-- 帮亲友付款 -->
            <div class="help-pay-for-btn" @click="toHelpPayFor">帮亲友付款</div>
        </div>
        <!-- 已经有人帮付款 -->
        <div class="already-pay" v-if="helpPayForFlag==false">
            <div class="pay-for-money">
                <div class="pay-for-money-text2">代付金额:</div>
                <div class="pay-for-money-before2">￥</div>
                <div class="pay-for-money-price2">{{payForMoney}}</div>
            </div>
            <div class="already-pay-text">已有人帮他/她付款</div>
        </div>
        
        <!-- 代付说明 -->
        <div class="help-pay-tips">
            <div class="tips-title">代付说明</div>
            <div class="tips-con">
                <div class="first-tips">1、代付产品是为了方便亲友之间付款而设计的，付款前请您务必和亲友再次确认，避免遇到诈骗行为。</div>
                <div class="second-tips">2、付款金额以当前页面展示为准。</div>
                <div class="third-tips">3、如果发生退款，已支付金额将原路返回付款人。</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import api from "../../api/api";
export default {
  name: 'helpPayFor',
  data(){
      return{
          preOrderId: 0,
          preOrderMsg:{},
          helpPayForFlag:true,//代付
        //   helpPayForFlag:false,//已有人代付
          expirationTime:'2020-09-25',
          userHeadImg: '',
          userNickName:'',
          userPhone:'',
          shopNick:"",
          goodsName:"",
          payForMoney:'',
          qrcode:'', // 店铺二维码
      }
  },
  methods:{
      changePhoneStyle(){
          this.userPhone = this.userPhone.substring(0,3)+'****'+this.userPhone.substring(7,11)
      },
      toHelpPayFor(){
          console.log("帮亲友付款")

          //跳转小程序后进行下单  下单完成后调起小程序支付
          wx.miniProgram.navigateTo({url: "../../my/pay/pay?preOrderId="+this.preOrderId});

          //通过预付单创建订单
          // let pop = {
          //     'preOrderId':this.preOrderId,
          // }
          // api.createOrderByPre(pop).then(res=>{
          //   console.log("order",res.data)
          //     //创建订单后返回数据
          //     console.log("status ",res.success)
          //   if (res.success){
          //       //TODO 下单成功 调用微信支付
          //       //res.orderId 为订单id
          //       console.log("下单成功 唤起支付")
          //       //微信支付
          //       // 付款成功后跳转到支付详情页面 失败跳转失败页面
          //         this.$router.push('/helpPayForDetail')
          //   }else {
          //       console.log("下单失败")
          //
          //       //跳转失败页面
          //       alert(res.msg)
          //   }
          // }).catch(err=>{
          //     console.log("err",err)
          // })



      },
      getPreOrderMsg(){
          let params = {
              // id:105176534876161
              id:this.preOrderId
          }
          api.getPreOrderMsg(params).then(res=>{
              console.log("preOrderMsg",res.data)
              let orderStatus = res.data.status;
              //判断预付订单状态
              if (orderStatus === 'paid'){ //已支付
                this.helpPayForFlag = true;
                return
              }else if(orderStatus === 'expired'){ //已过时 跳转超时页面
                  this.$router.push({
                      path: "/helpPayForFaile",
                      query: {},
                  });
              }

              this.preOrderMsg = res.data;
              this.userNickName =res.data.buyer.wxName;
              this.userHeadImg =res.data.buyer.wxAvatarUrl;
              this.userPhone = this.preOrderMsg.buyer.phone;
              this.changePhoneStyle()
              this.payForMoney = this.preOrderMsg.product.promotionPriceStr;
              this.goodsName = this.preOrderMsg.product.title;

              //获取店铺信息
              let shopParam = {
                  shopId:this.preOrderMsg.product.shopId
              }
              api.getShopInfo(shopParam).then(res=>{
                  this.shopNick = res.data.shopName
              }).catch(err=>{
                  console.log("shopInfo error")
              })
          }).catch(err=>{
              console.log("error")
          })
      }
  },
  created(){
        document.title = "代付付款";
        this.preOrderId = this.$route.params.preOderId;
        // this.preOrderId = 105250929246209;
        this.getPreOrderMsg();
  },
  mounted(){
      this.changePhoneStyle()
  },
  components:{
        vueQr
    },
}
</script>
<style lang="scss">
    body{
        margin:0;
        padding:0;
        width: 100%;
        height: 100%;
        background: url('../../assets/images/bg@2x.png') no-repeat;
    }
    .helpPayFor{
        width: 100%;
        height: 100%;
        // 顶部用户信息
        .top-con{
            // width: 100%;
            display: flex;
            .user-img{
                margin:18px 12px 24px 18px;
                width: 40px;
                height: 40px;
                border-radius: 20px;
                img{
                    width: 40px;
                    height: 40px;
                    border-radius: 20px;
                }
            }
            .user-message{
                margin:18px 15px 16px 0px;
                display: flex;
                flex-direction: column;
                .user-nickName-phone{
                    display: flex;
                    // align-items: center;
                    .nickName{
                        max-width: 160px;
                        height: 22px;
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: bold;
                        color: #FFFFFF;
                        line-height: 22px;
                        text-align-last: left;
                    }
                    .phone{
                        width: 138px;
                        height: 22px;
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: bold;
                        color: #FFFFFF;
                        line-height: 22px;
                        text-align: left;
                    }   
                }
                // 友情提示
                .tips{
                    margin-top:6px;
                    width: 284px;
                    height: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 20px;
                    text-align: left;
                }
            }
        }
        // 店铺及商品名称
        .shop-goods-content{
            width: 90%;
            height: 97px;
            // background: #FFEFEF;
            background: url('../../assets/images/top-bg.png') no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            .shop-nick{
                // width: 270px;
                height: 16px;
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #590707;
                line-height: 16px;
                margin: 0 auto;
                padding-top:24px;
            }
            .goods-name{
                // width: 163px;
                height: 16px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #590707;
                line-height: 16px;
                margin: 0 auto;
                padding-top:18px;
            }
        }
        // 待付款二维码
        .pay-for-content{
            width: 90%;
            height: 405px;
            // background: #FFEFEF;
            background: url('../../assets/images/bottom-bg.png') no-repeat;
            background-size: 100% 100%;
            margin:0 auto;
            // 代付金额
            .pay-for-money-text{
                // width: 69px;
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #F52B23;
                line-height: 22px;
                font-weight: bold;
                padding-top:37px;
                padding-bottom:5px;
                margin:0 auto;
                text-align: center;
            }
            .pay-for-money-price-con{
                display: flex;
                justify-content: center;
                margin:0 auto;
                width: 100px;
                height: 37px;
                padding-bottom:40px;
                .pay-for-money-before{
                    width: 11px;
                    height: 11px;
                    font-size: 16px;
                    color: #F52B23;
                    padding:10px 6px 0px 0px;
                    font-weight: 600;

                 }
                .pay-for-money-price{
                    height: 37px;
                    font-size: 26px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: bold;
                    color: #F52B23;
                    line-height: 37px;
                    font-weight: bold;
                }
            }
            .pay-for-money{
                height: 37px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 37px;
                padding-bottom: 27px;
                .pay-for-money-text2{
                    height: 22px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color:#590707;
                    line-height: 22px;
                    font-weight: bold;
                }
                .pay-for-money-before2{
                    padding:0px 6px 4px 11px;
                    // width: 11px;
                    // height: 11px;
                    font-size: 18px;
                    color:#590707;
                    font-weight: 600;
                }
                .pay-for-money-price2{
                    width: 86px;
                    height: 37px;
                    font-size: 26px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color:#590707;
                    line-height: 37px;
                    font-weight: bold;
                }
                
            }
            .already-pay-text{
                    width: 136px;
                    height: 16px;
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #590707;
                    line-height: 16px;
                    padding-top: 10px;
                    margin: 0 auto;
                    margin-bottom:31px;
                }
            // 帮亲友付款 
            .help-pay-for-btn{
                width: 250px;
                height: 45px;
                background: #F44451;
                border-radius: 25px;
                margin: 0 auto;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 45px
            }
            // 代付说明 
            .help-pay-tips{
                width: 317px;
                height: 102px;
                margin:0 auto;
                padding-top: 86px;
                .tips-title{
                    width: 48px;
                    height: 16px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 16px;
                    padding-bottom:6px;
                }
                .tips-con{
                    width: 317px;
                    height: 80px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #888888;
                    line-height: 20px;
                    text-align: left;
                }
            }
        }
    }
</style>